const fakeData = [
  [
    {
      id: 0,
      // first_name: ".........",
      // last_name: "Kelvin Gutkowski II",
      // email: "Alfreda_Herzog@yahoo.com",
      // genre: "....",
      // ip_address: "161.252.103.145",
    },
  ],
];
export default fakeData;
